import { useMemo } from 'react'
import { Platform, ScaledSize, useWindowDimensions } from 'react-native'
import { defaults, gap, header, padding, topbar, widthDefault } from './values'

export const getMaxDimensions = (size: ScaledSize) => {
  return {
    ...size,
    width: Math.min(size.width, widthDefault),
  }
}

export const useMaxWindowDimensions = () => {
  const dimensions = useWindowDimensions()

  return useMemo(() => getMaxDimensions(dimensions), [dimensions])
}

const H = (h?: number, extra?: number, i?: number) => {
  const height = h || 0
  const items = i || 1
  const gaps = gap * (items - 1)
  return (height - gaps - (extra || 0)) / items
}

export const useRWD = () => {
  const maxWinowsDimensions = useMaxWindowDimensions()
  const width = maxWinowsDimensions.width
  const height = maxWinowsDimensions.height

  const w = {
    '1/1': width - 2 * gap,
    '1/2': (width - 3 * gap) / 2,
  }

  const introTopSection = 104
  const introTopSpace = introTopSection + gap

  const introTileWidth = Math.ceil((width - 2 * padding - gap) / 2)

  // const introBannerHeight = Platform.select({
  //   default: height - introTopSpace - 2 * introTileWidth - 4 * gap,
  //   web:
  //     defaults.height.default -
  //     introTopSpace -
  //     2 * Math.ceil((defaults.width.default - 2 * padding - gap) / 2) -
  //     4 * gap,
  // })

  const introSlideWidth = width - 2 * padding
  const introSlideHeight = Platform.select({
    default: height - introTopSection - gap - padding,
    // web: 2 * introTileWidth + 2 * gap + introBannerHeight,
    web: 2 * introTileWidth + gap,
  })

  const input = 48 - 4 // Input Height
  const layout = height - topbar.height // Layout Height
  const page = layout - header.height // Page Height

  const tileBlurWidth = w['1/2']
  const tileBlurHeight = Platform.select({
    default: H(layout, 2 * gap, 3),
    web: H(layout, 2 * gap, 5),
  })

  const tileBlurOptionWidth = w['1/2']
  const tileBlurOptionHeight = Platform.select({
    default: H(page, gap, 3),
    web: H(page, gap, 5),
  })

  const tileFrameWidth = w['1/2']
  const tileFrameHeight = Platform.select({
    default: H(page - input, 3 * gap, 3),
    web: H(page - input, 3 * gap, 5),
  })

  const tileColorWidth = w['1/2']
  const tileColorHeight = Platform.select({
    default: H(page, gap, 5),
    web: H(page, gap, 8),
  })

  const tileOptionWidth = w['1/2']
  const tileOptionHeight = Platform.select({
    default: H(page, gap, 2),
    web: H(page, gap, 3),
  })

  const tileUserWidth = w['1/2']
  const tileUserHeight = Platform.select({
    default: H(page - input, 2 * gap, 4),
    web: H(page - input, 2 * gap, 8),
  })

  const videoWidth = w['1/1']
  const videoHeight = (9 / 16) * videoWidth
  const videoMaxHeight = page - tileOptionHeight - 2 * gap

  return {
    screen: {
      width,
      height,
    },
    intro: {
      topSpace: introTopSpace,
      slide: {
        width: introSlideWidth,
        height: introSlideHeight,
      },
      tile: {
        width: introTileWidth,
        height: introTileWidth,
      },
      // banner: {
      //   height: introBannerHeight,
      // },
    },
    tiles: {
      blur: {
        width: tileBlurWidth,
        // height: Math.max(tileBlurHeight, 294),
        height: Platform.select({
          default: 285,
          web: Math.max(H(layout, 2 * gap, 5), 294),
        }),
      },
      blurOption: {
        width: tileBlurOptionWidth,
        // height: Math.max(tileBlurOptionHeight, 241),
        height: Platform.select({
          default: 237,
          web: Math.max(H(layout, 2 * gap, 5), 237),
        }),
      },
      option: {
        width: tileOptionWidth,
        height: Math.max(
          tileOptionHeight,
          Platform.select({ default: 372, web: 436 })
        ),
        image: {
          height: Platform.select({
            default: 100,
            web: 128,
          }),
        },
      },
      frame: {
        width: tileFrameWidth,
        height: Math.max(tileFrameHeight, 207),
      },
      color: {
        width: tileColorWidth,
        height: Math.max(tileColorHeight, 128),
      },
      user: {
        width: tileUserWidth,
        height: Math.max(tileUserHeight, 157),
      },
      answer: {
        width: w['1/1'],
        height: Math.max(
          Platform.select({
            default: H(page, 4 * gap + 48, 3),
            web: H(page, 4 * gap + 48, 5),
          }),
          192
        ),
        image: {
          height: Platform.select({
            default: 128,
            web: 128,
          }),
        },
      },
    },
    video: {
      width: videoWidth,
      height: videoHeight,
      maxHeight: videoMaxHeight,
    },
  }
}

export default useRWD
